<template>
	<article
		class="c-chart-box__wrapper"
		:class="{ 'c-chart-box__wrapper--horizontal' : vm.CurrentBlock.LayoutType === '1' }"
	>
		<slot name="introduction"></slot>
		<InfiniteScroll
			v-if="formattedChartType === 'bar'"
			is-first-page-loaded
			@trigger="animate"
		>
			<DsText
				v-if="vm.CurrentBlock.ChartHeadline"
				html-element="h3"
				:text-type="vm.CurrentBlock.LayoutType === '1' ? 'heading-lg' : 'heading-2xl'"
				:text-style="vm.CurrentBlock.LayoutType === '1' ? 'regular' : 'medium'"
				class="c-chart-box__headline"
				:class="{ 'c-chart-box__headline--horizontal' : vm.CurrentBlock.LayoutType === '1' }"
			>
				{{ vm.CurrentBlock.ChartHeadline }}
			</DsText>
			<Apexchart
				:width="windowWidth >= 888 ? 840 : '100%'"
				:height="480"
				:type="formattedChartType"
				:options="barColumn.options"
				:series="barColumn.series"
			/>
		</InfiniteScroll>
		<InfiniteScroll
			v-if="formattedChartType !== 'bar'"
			is-first-page-loaded
			@trigger="animate"
		>
			<DsText
				v-if="vm.CurrentBlock.ChartHeadline"
				html-element="h3"
				:text-type="vm.CurrentBlock.LayoutType === '1' ? 'heading-lg' : 'heading-2xl'"
				:text-style="vm.CurrentBlock.LayoutType === '1' ? 'regular' : 'medium'"
				class="c-chart-box__headline"
				:class="{ 'c-chart-box__introduction--horizontal' : vm.CurrentBlock.LayoutType === '1' }"
			>
				{{ vm.CurrentBlock.ChartHeadline }}
			</DsText>
			<Apexchart
				ref="chart"
				:width="windowWidth >= 888 ? 840 : '100%'"
				:height="567"
				:type="formattedChartType"
				:options="pieDonut.options"
				:series="pieDonut.series"
			/>
		</InfiniteScroll>
	</article>
</template>

<script>
	import Apexchart from 'vue3-apexcharts';
	import InfiniteScroll from 'shared/components/InfiniteScroll.vue';
	import { DsText } from '@coloplast/design-system';

	export default {
		components: {
			Apexchart,
			InfiniteScroll,
			DsText,
		},
		props: {
			vm: {
				type: Object,
				default: () => {},
			},
			dataVm: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return {
				isVisible: false,
				windowWidth: window.innerWidth,
				barColumn: {
					series: this.vm.CurrentBlock.IsAnimationEnabled === 'True' ? [] : this.dataVm.BaseViewModel.map((item) => {
					return {
						name: item.Label,
						data: [item.Value],
					}}),
					options: {
						chart: {
							redrawOnParentResize: true,
							redrawOnWindowResize: true,
							toolbar: {
								show: false,
							},
							fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
							foreColor: '#4D646B',
							dropShadow: {
								enabled: false,
							},
							animations: {
								enabled: this.vm.CurrentBlock.IsAnimationEnabled === 'True',
								easing: 'easeinout',
								speed: 800,
								animateGradually: {
									enabled: true,
									delay: 150,
								},
								dynamicAnimation: {
									enabled: this.vm.CurrentBlock.IsAnimationEnabled === 'True',
									speed: 800,
								},
							},
						},
						plotOptions: {
							bar: {
								horizontal: this.vm.CurrentBlock.ChartType === 'bar horizontal',
							},
						},
						dataLabels: {
							enabled: false,
						},
						xaxis: {
							categories: this.dataVm.BaseViewModel.map((item) => item.Label),
							overwriteCategories: this.dataVm.BaseViewModel.map((item) => item.Label),
							labels: {
								show: this.vm.CurrentBlock.ChartType === 'bar horizontal',
								style: {
									fontSize: '12px',
									fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
									fontWeight: 426,
								},
								rotate: 0,
							},
							title: {
								text: this.vm.CurrentBlock.XAxisLabel,
								style: {
									color: '#4D646B',
									fontSize: '12px',
									fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
									fontWeight: 500,
								},
							},
							position: 'bottom',
							axisBorder: {
								show: true,
								color: '#7A8B90',
							},
							axisTicks: {
								show: false,
							},
							crosshairs: {
								show: false,
							},
						},
						yaxis: {
							title: {
								text: this.vm.CurrentBlock.YAxisLabel,
								style: {
									color: '#4D646B',
									fontSize: '12px',
									fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
									fontWeight: 500,
								},
							},
							labels: {
								show: this.vm.CurrentBlock.ChartType !== 'bar horizontal',
								style: {
									fontSize: '12px',
									fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
									fontWeight: 426,
								},
							},
							axisBorder: {
								show: true,
								color: '#7A8B90',
							},
							crosshairs: {
								show: false,
							},
						},
						colors: [
							'#00A2BA',
							'#7a8b90',
							'#213D46',
							'#F17E64',
							'#006A7A',
							'#88BE75',
							'#B3E3ED',
							'#378C87',
							'#FBAB61',
						],
						fill: {
							opacity: 1,
						},
						grid: {
							show: true,
							borderColor: '#DDE2E4',
							position: 'back',
							xaxis: {
								lines: {
									show: this.vm.CurrentBlock.ChartType === 'bar horizontal',
								},
							},
							yaxis: {
								lines: {
									show: this.vm.CurrentBlock.ChartType !== 'bar horizontal',
								},
							},
						},
						stroke: {
							show: true,
							width: this.vm.CurrentBlock.ChartType !== 'bar horizontal' ? 90 : 8,
							colors: ['transparent'],
						},
						tooltip: {
							enabled: true,
							followCursor: true,
							fillSeriesColor: false,
							theme: 'light',
							style: {
								fontSize: '12px',
								fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
							},
							background: {
								enabled: true,
								foreColor: '#fff',
								borderRadius: 8,
								borderWidth: 1,
								borderColor: '#CAD0D3',
								opacity: 1,
								dropShadow: {
									enabled: false,
								},
							},
							onDatasetHover: {
								highlightDataSeries: false,
							},
							x: {
								show: false,
							},
							marker: {
								show: true,
							},
						},
						legend: {
							show: true,
							showForSingleSeries: true,
							showForNullSeries: true,
							showForZeroSeries: true,
							position: 'bottom',
							horizontalAlign: 'left',
							floating: false,
							fontSize: '12px',
							fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
							fontWeight: 426,
							width: 700,
							offsetY: 12,
							itemMargin: {
								horizontal: 16,
								vertical: 4,
							},
							markers: {
								width: 10,
								height: 10,
								radius: 10,
								offsetX: -8,
							},
							onItemHover: {
								highlightDataSeries: true,
							},
							onItemClick: {
								toggleDataSeries: false,
							},
						},
						states: {
							normal: {
								filter: {
									type: 'none',
									value: 0,
								},
							},
							hover: {
								filter: {
									type: 'darken',
									value: 0.4,
								},
							},
							active: {
								allowMultipleDataPointsSelection: false,
								filter: {
									type: 'darken',
									value: 0.4,
								},
							},
						},
						responsive: [
							{
								breakpoint: 740,
								options: {
									legend: {
										width: '100%',
									},
									stroke: {
										width: this.vm.CurrentBlock.ChartType !== 'bar horizontal' ? 24 : 8,
									},
									xaxis: {
										labels: {
											show: this.vm.CurrentBlock.ChartType === 'bar horizontal',
										},
									},
									yaxis: {
										labels: {
											show: this.vm.CurrentBlock.ChartType !== 'bar horizontal',
										},
									},
									tooltip: {
										followCursor: false,
										marker: {
											show: false,
										},
										fixed: {
											enabled: true,
											position: 'topLeft',
											offsetY: this.vm.CurrentBlock.ChartType === 'bar horizontal' ? 0 : 50,
										},
									},
								},
							},
						],
					},
				},
				pieDonut: {
					series: this.dataVm.BaseViewModel.map((item) => item.Value),
					options: {
						chart: {
							redrawOnParentResize: true,
							redrawOnWindowResize: true,
							fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
							foreColor: '#4D646B',
							dropShadow: {
								enabled: false,
							},
							animations: {
								enabled: this.vm.CurrentBlock.IsAnimationEnabled === 'True',
								easing: 'easeinout',
								speed: 1200,
								animateGradually: {
									enabled: true,
									delay: 150,
								},
								dynamicAnimation: {
									enabled: this.vm.CurrentBlock.IsAnimationEnabled === 'True',
									speed: 1200,
								},
							},
						},
						tooltip: {
							enabled: true,
							followCursor: true,
							fillSeriesColor: false,
							theme: 'light',
							style: {
								fontSize: '12px',
								fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
							},
							background: {
								enabled: true,
								foreColor: '#fff',
								borderRadius: 8,
								borderWidth: 1,
								borderColor: '#CAD0D3',
								opacity: 1,
								dropShadow: {
									enabled: false,
								},
							},
							onDatasetHover: {
								highlightDataSeries: false,
							},
							x: {
								show: false,
							},
							y: {
								formatter: function (value) {
									return value + '%';
								},
							},
							marker: {
								show: false,
							},
						},
						labels: this.dataVm.BaseViewModel.map((item) => item.Label),
						plotOptions: {
							pie: {
								donut: {
									size: this.vm.CurrentBlock.ChartType === 'donut' ? '40%' : 0,
								},
								expandOnClick: false,
								customScale: 0.72,
								dataLabels: {
									offset: this.vm.CurrentBlock.ChartType === 'donut' ? 90 : 70,
								},
							},
						},
						grid: {
							borderColor: '#DDE2E4',
						},
						dataLabels: {
							enabled: true,
							distributed: true,
							style: {
								fontSize: '16px',
								fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
								fontWeight: 426,
								colors: ['#4D646B'],
								dropShadow: false,
							},
							dropShadow: {
								enabled: false,
							},
						},
						colors: [
							'#00A2BA',
							'#7a8b90',
							'#213D46',
							'#F17E64',
							'#006A7A',
							'#88BE75',
							'#B3E3ED',
							'#378C87',
							'#FBAB61',
						],
						fill: {
							opacity: 1,
						},
						legend: {
							show: true,
							showForSingleSeries: true,
							showForNullSeries: true,
							showForZeroSeries: true,
							position: 'bottom',
							horizontalAlign: 'left',
							floating: false,
							fontSize: '12px',
							fontFamily: '"Coloplast Sans", Arial, Helvetica, sans-serif',
							fontWeight: 426,
							width: 700,
							itemMargin: {
								horizontal: 16,
								vertical: 4,
							},
							markers: {
								width: 10,
								height: 10,
								radius: 10,
								offsetX: -8,
							},
							onItemHover: {
								highlightDataSeries: true,
							},
							onItemClick: {
								toggleDataSeries: false,
							},
						},
						states: {
							normal: {
								filter: {
									type: 'none',
									value: 0,
								},
							},
							hover: {
								filter: {
									type: 'darken',
									value: 0.4,
								},
							},
							active: {
								allowMultipleDataPointsSelection: false,
								filter: {
									type: 'darken',
									value: 0.4,
								},
							},
						},
						responsive: [
							{
								breakpoint: 740,
								options: {
									legend: {
										width: '100%',
									},
									tooltip: {
										followCursor: false,
										marker: {
											show: false,
										},
										fixed: {
											enabled: true,
											position: 'topLeft',
											offsetY: 0,
										},
									},
								},
							},
						],
					},
				},
			};
		},
		computed: {
			formattedChartType() {
				if (this.vm.CurrentBlock.ChartType === 'bar horizontal') {
					return 'bar';
				} else {
					return this.vm.CurrentBlock.ChartType;
				}
			},
		},
		mounted() {
			window.addEventListener('resize', this.onWidthChange);
			this.onWidthChange();
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.onWidthChange);
		},
		methods: {
			animate() {
				let chartData = this.vm.CurrentBlock.ChartType.startsWith('bar') ? 'barColumn' : 'pieDonut';
				if (!this.isVisible) {
					if (chartData === 'barColumn') {
						this.barColumn.series = this.dataVm.BaseViewModel.map((item) => {
							return {
								name: item.Label,
								data: [item.Value],
							};
						});
					} else {
						this.$refs.chart.refresh();
					}
					this.isVisible = true;
				}
			},
			onWidthChange() {
				this.windowWidth = window.innerWidth;
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import 'multisite/styles/settings/settings';
	@import 'multisite/styles/tools/tools';

	:deep {
		.apexcharts-legend-series:hover {
			.apexcharts-legend-marker {
				position: relative;
				transition: 0.15s ease all;

				&::after {
					content: '';
					position: absolute;
					top: -4px;
					left: -4px;
					height: 18px;
					width: 18px;
					border-radius: 500px;
					background: currentColor;
					opacity: 0.5;
				}
			}
		}

		.apexcharts-tooltip {
			box-shadow: 0 2px 2px rgba(21, 39, 45, 0.08), 0 4px 8px rgba(21, 39, 45, 0.08);
			white-space: pre-wrap;
			max-width: calc(100vw - 48px);
		}

		.apexcharts-tooltip-title {
			font-weight: ds-font-weight("medium");
		}

		.apexcharts-pie-label,
		.apexcharts-datalabels,
		.apexcharts-datalabel,
		.apexcharts-datalabel-label,
		.apexcharts-datalabel-value {
			opacity: 1;
		}

		.apexcharts-datalabel.apexcharts-element-hidden {
			opacity: 0;
		}

		.apexcharts-bar-area,
		.apexcharts-series {
			transition: 0.15s ease all;
		}

		.apexcharts-series.legend-mouseover-inactive {
			opacity: 0.2;
		}

		.apexcharts-pie-area:hover {
			stroke: transparent;
			stroke-opacity: 0;
			stroke-width: 0;
		}
	}
</style>
